export const enablePreventRefresh = () => {
    window.onbeforeunload = (event: BeforeUnloadEvent) => {
        event.preventDefault()
    }
}

export const disablePreventRefresh = () => {
    window.onbeforeunload = null
}
